<app-page-header [heading]="heading" [description]="description" [breadcrumbs]="breadcrumbs" [background]="'skyline'"></app-page-header>
<div class="section-color" style="padding-bottom: 100px;">
    <div style="height: 100px;"></div>
    <app-section-values></app-section-values>
</div>